// Pure, testable logic for the Bible version (translation) selector.
//
// Why this exists: a version switch must never silently break. RVR1960 is
// copyrighted (Sociedades Bíblicas Unidas) and cannot be self-hosted, so we
// steer it to the closest free match (Reina-Valera Gómez / RVG). Keeping this
// as a pure function lets us unit-test every version transition — including
// the RVR1960 -> RVG redirect — without rendering the huge reader component.

// Copyrighted versions we cannot serve, mapped to their free stand-in.
export const COPYRIGHTED_FALLBACKS = {
  RVR1960: 'RVG',
};

/**
 * Resolve which translation should actually load for a requested version code.
 * @param {string} code - the version the user picked (e.g. 'KJV', 'RVR1960').
 * @returns {{ translation: string, redirected: boolean, from?: string }}
 */
export function resolveTranslationSelection(code) {
  const fallback = COPYRIGHTED_FALLBACKS[code];
  if (fallback) {
    return { translation: fallback, redirected: true, from: code };
  }
  return { translation: code, redirected: false };
}
